import { LAYOUT_ID, Stack, Tag, Text, Tooltip } from "@certa/blocks/thanos";
import {
  Button,
  ButtonSizes,
  ButtonTypes
} from "@certa/catalyst/components/Button";
import { Eye } from "@certa/icons/components/Eye";
import { UserGroup } from "@certa/icons/components/UserGroup";
import type { SelectOption } from "@certa/types";
import { ClassNames } from "@emotion/core";
import type { ReactElement } from "react";
import { useIntl } from "react-intl";

type Props = {
  accessibleBy: SelectOption[];
};

export const AccessibleTagsPopover = ({
  accessibleBy
}: Props): ReactElement => {
  const intl = useIntl();
  return (
    <ClassNames>
      {({ cx, css }) => (
        <Tooltip
          id="tooltip"
          placement="bottomRight"
          overlayClassName={css`
            &.ant-tooltip {
              .ant-tooltip-arrow:before {
                background: var(--neutral-0);
              }
              .ant-tooltip-inner {
                border-radius: var(--big-border-radius);
                background: var(--neutral-0);
                color: var(--neutral-70);
                font-size: var(--p3);
                line-height: var(--p3-line-height);
                font-weight: var(--regular);
                padding: var(--s4);
                min-height: 28px;
                min-width: 300px;
                align-items: center;
                & > * {
                  flex-grow: 1;
                }
              }
            }
          `}
          getPopupContainer={() =>
            document.getElementById(LAYOUT_ID) || document.body
          }
          overlay={
            <Stack direction="vertical" gap="s3" align={"flex-start"}>
              <Text variant="p2-bold-upper">
                {intl.formatMessage({
                  id: "tasklaneProgress.accessibleBy",
                  defaultMessage: "Accessible By"
                })}
              </Text>
              <Stack style={{ flexWrap: "wrap" }}>
                {accessibleBy?.map(({ label, value }) => (
                  <Tag
                    icon={<UserGroup color="neutral-100" autoSize />}
                    key={value}
                  >
                    <Text variant="p1-medium" color="neutral-100">
                      {label}
                    </Text>
                  </Tag>
                ))}
              </Stack>
            </Stack>
          }
        >
          <Button
            leftIcon={<Eye />}
            size={ButtonSizes.SMALL}
            type={ButtonTypes.ICON}
            aria-label="Accessible By"
          />
        </Tooltip>
      )}
    </ClassNames>
  );
};
